
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("cjS4E", function(module, exports) {

$parcel$export(module.exports, "NavigationAppsNavItemWrapperNudge", () => $8fde279c95d01a09$export$1fe86ed9f13a9f2d);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7dRgX = parcelRequire("7dRgX");

var $5e1YW = parcelRequire("5e1YW");

var $8jHS3 = parcelRequire("8jHS3");

var $4LQ2W = parcelRequire("4LQ2W");

var $8Pxhe = parcelRequire("8Pxhe");
const $8fde279c95d01a09$export$1fe86ed9f13a9f2d = ({ children: children, nudgeId: nudgeId, isInsideMenu: isInsideMenu })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const shouldShowNudge = (0, $4LQ2W.useCanShowQuickstartNudge)();
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5e1YW.QuickstartNudge), {
        nudgeId: nudgeId,
        itemNames: [
            (0, $7dRgX.CAPTURE_INTEGRATIONS_TASK),
            (0, $7dRgX.DEVOPS_CAPTURE_INTEGRATIONS_TASK)
        ],
        // @ts-expect-error - TS2322 - Type 'StyledComponentClass<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { isHidden: boolean; }, any, ClassAttributes<...> & HTMLAttributes<...> & { ...; }>' is not assignable to type 'ComponentType<QuickstartNudgeContainerComponentProps> | undefined'.
        ContainerComponent: (0, $8jHS3.NavigationItemContainer),
        nudgeSpotlightCardProps: {
            content: formatMessage((0, $8Pxhe.default).content),
            width: 320
        },
        isInsideMenu: isInsideMenu
    }, children);
};

});
parcelRegister("5e1YW", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $43695f19b459f7b9$export$bd61ee610c74db6c);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

var $ewdMq = parcelRequire("ewdMq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $43695f19b459f7b9$var$LazyQuickstartNudge = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("Qdl06")).then((exportedModule)=>exportedModule.QuickstartNudge), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-quickstart-core/src/common/ui/quickstart-nudge/main.tsx"
});
const $43695f19b459f7b9$export$bd61ee610c74db6c = ({ children: children = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewdMq.OnboardingNudgeErrorBoundary), {
        id: "quickstartNudge",
        fallback: children,
        attributes: {
            nudgeId: props.nudgeId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "software-quickstart-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($43695f19b459f7b9$var$LazyQuickstartNudge, props, children)));

});
parcelRegister("Qdl06", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("hcE3v").then(()=>parcelRequire('acTQT'));

});


parcelRegister("8jHS3", function(module, exports) {

$parcel$export(module.exports, "NudgeFriendlyStylesOutsideMenuNew", () => $a72b543706d2a536$export$4299fc1671a3b97a);
$parcel$export(module.exports, "NavigationItemContainer", () => $a72b543706d2a536$export$7b395d2783a866d1);
$parcel$export(module.exports, "FormNudgeWrapper", () => $a72b543706d2a536$export$c85e793bd6d53417);
$parcel$export(module.exports, "CreateColumnContainer", () => $a72b543706d2a536$export$ec10f41ee4242a6e);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");
const $a72b543706d2a536$var$NoCSSOverrides = /*#__PURE__*/ (0, $kwce8.css)({});
const $a72b543706d2a536$var$UnderlineFriendlyInsideMenu = $a72b543706d2a536$var$NoCSSOverrides;
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $a72b543706d2a536$var$UnderlineFriendlyOutsideMenu = /*#__PURE__*/ (0, $kwce8.css)`& > span{display:inline;}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/design-system/no-css-tagged-template-expression
const $a72b543706d2a536$var$UnderlineFriendlyStyles = /*#__PURE__*/ (0, $kwce8.css)`${({ isInsideMenu: isInsideMenu })=>isInsideMenu ? $a72b543706d2a536$var$UnderlineFriendlyInsideMenu : $a72b543706d2a536$var$UnderlineFriendlyOutsideMenu}`;
const $a72b543706d2a536$var$NudgeFriendlyStylesInsideMenu = $a72b543706d2a536$var$NoCSSOverrides;
const $a72b543706d2a536$export$56f7f4387c2aff0d = /*#__PURE__*/ (0, $kwce8.css)({
    display: 'flex',
    alignItems: 'center'
});
const $a72b543706d2a536$export$4299fc1671a3b97a = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a72b543706d2a536$var$NudgeFriendlyStyles = /*#__PURE__*/ (0, $kwce8.css)`${({ isInsideMenu: isInsideMenu })=>isInsideMenu ? $a72b543706d2a536$var$NudgeFriendlyStylesInsideMenu : $a72b543706d2a536$export$56f7f4387c2aff0d}`;
const $a72b543706d2a536$export$7b395d2783a866d1 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1ghml2v-0"
})`${({ isHidden: isHidden })=>isHidden ? $a72b543706d2a536$var$UnderlineFriendlyStyles : $a72b543706d2a536$var$NudgeFriendlyStyles}`;
const $a72b543706d2a536$export$c85e793bd6d53417 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1f021osq _nbgx120u _guz21b66",
            __cmplp.className
        ])
    });
});
const $a72b543706d2a536$export$ec10f41ee4242a6e = ({ children: children, isHidden: isHidden })=>isHidden ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a72b543706d2a536$var$CreateColumnContainerHidden, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a72b543706d2a536$var$CreateColumnContainerNonHidden, null, children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a72b543706d2a536$var$CreateColumnContainerNonHidden = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yg612x7 _hjaqutpp _1npctij8 _4d7t1if8 _o5fvtij8 _1a0dze3t",
            __cmplp.className
        ])
    });
});
const $a72b543706d2a536$var$CreateColumnContainerHidden = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1f021osq _tsvm1osq _10s6glyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8Pxhe", function(module, exports) {

$parcel$export(module.exports, "default", () => $97a8e7d5d975d735$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $97a8e7d5d975d735$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    content: {
        "id": "software-onboarding-nudges--next.navigation-apps.content",
        "defaultMessage": "Search for the tools you currently use, or discover something new."
    }
});

});



//# sourceMappingURL=async-software-onboarding-navigation-apps-nudge.aa4d7b45.js.map
